import { CustomerOriginType, CustomerSynchronizedStatus } from '../types/customer.enum';
import { CustomerAddress, CustomerCreatedBy } from '../types/customer.types';

export const whatsappLink = 'https://api.whatsapp.com';

interface GetWhatsAppLinkParams {
  phone?: string;
  message?: string;
  countryCode?: string;
}

export const getWhatsAppLink = ({ countryCode, message, phone }: GetWhatsAppLinkParams) => {
  if (phone) {
    return `${whatsappLink}/send?phone=${countryCode || '55'}${phone}${
      message ? `&text=${message}` : ''
    }`;
  }

  if (message) {
    return `${whatsappLink}/send?text=${message}`;
  }

  return `${whatsappLink}/`;
};

export const getCustomerPrincipalAddress = (addresses?: CustomerAddress[]): string | undefined => {
  if (!addresses || !addresses?.length) {
    return;
  }

  const principalAddress = addresses.find((address) => address.principal);

  if (!principalAddress) {
    return;
  }

  return `${principalAddress.address.city} - ${principalAddress.address.state}`;
};

export const isCustomerSyncingOrCompleted = (
  syncStatus: CustomerSynchronizedStatus | undefined,
) => {
  if (!syncStatus) {
    return false;
  }

  return [CustomerSynchronizedStatus.PROCESSING, CustomerSynchronizedStatus.SUCCESS].includes(
    syncStatus,
  );
};

export const shouldShowCreatedBy = (origin?: CustomerOriginType, createdBy?: CustomerCreatedBy) => {
  if (!createdBy?.name || !origin) {
    return false;
  }

  if (![CustomerOriginType.MANUAL, CustomerOriginType.SPREADSHEET_IMPORT].includes(origin)) {
    return false;
  }

  return true;
};
